import { type UseQueryResult, useQuery } from 'react-query';
import {
  DashboardAppSharedService,
  DashboardService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardService_Dtos_ParticipantTask_UpComingEventsDto,
} from '../../services/wealthlane-award-services';
import { ParticipantUpcomingEventsService } from '../../services/wealthlane-award-services/services/ParticipantUpcomingEventsService';

const useGetParticipantDashboardUpcomingEvent = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
  //   isOnBoarded?: boolean
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardService_Dtos_ParticipantTask_UpComingEventsDto[] | undefined,
  unknown
> => {
  const participantDashboardUpcomingEvent = useQuery(
    ['getParticipantDashboardUpcomingEvent'],
    async () => {
      //   if (isOnBoarded) {
      return await handleRequest(
        ParticipantUpcomingEventsService.getApiAwardApiAppDashboardParticipantUpcomingEvents()
      );
    }
    // }
  );
  return participantDashboardUpcomingEvent;
};

export default useGetParticipantDashboardUpcomingEvent;
